export default __webpack_public_path__ + "static/media/Article-image.f27fee9b.png";